























import { Component, Vue } from 'vue-property-decorator'
import {
  VQuery,
  VTable,
  QueryModel,
  TableHander,
  TableOperation
} from '@/components/table'
import { QueryAllShopNameList, QueryWithdrawOrder, ExportWithdrawOrder } from '@/api'
import {
  PriceFormat,
  WithdrawStatusFormat,
  BandCardFormat
} from '@/utils/tyepconvert'
import { DateFormat } from '@/utils/date/DateUtil'
import WithdrawAuditDialog from './components/WithdrawAuditDialog.vue'
import constan from '@/utils/constant'
import ShopWealhRecordDialog from '@/views/shop/components/ShopWealhRecordDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    WithdrawAuditDialog,
    ShopWealhRecordDialog
  }
})
export default class VideoList extends Vue {
  private WithdrawStatusFormat = WithdrawStatusFormat
  private queryParam: any = {
    startRow: 1,
    limit: 10,
    createTimeDaterange: [],
    applyPassTimeDaterange: [],
    withdrawSuccessTimeDaterange: [],
    withdrawRejectTimeDaterange: [],
  }
  private activeMenu: any = 'wait'
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private shopIdOption: Array<any> = []
  private shopIdQueryParam: QueryModel = {
    title: '店铺',
    param: 'shopId',
    type: 'select',
    selectData: this.shopIdOption
  }

  // 查询条件
  private queryModels: Array<QueryModel> = [
    this.shopIdQueryParam,
    {
      title: '提现状态',
      param: 'withdrawStatus',
      type: 'select',
      selectData: constan.WithdrawStatus
    },
    { title: '提现单号', param: 'withdrawCode' },
    { title: '申请时间', param: 'createTimeDaterange', type: 'daterange' },
    { title: '申请通过时间', param: 'applyPassTimeDaterange', type: 'daterange' },
    { title: '提现成功时间', param: 'withdrawSuccessTimeDaterange', type: 'daterange' },
    { title: '审核拒绝时间', param: 'withdrawRejectTime', type: 'daterange' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '导出', type: 'primary', click: this.exportHandle }
  ]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '店铺', param: 'shopName', width: 220 },
    { title: '提现单号', param: 'withdrawCode', overflow: true, width: 190 },
    {
      title: '提现金额',
      param: 'withdrawAmount',
      formatter: PriceFormat,
      width: 80
    },
    { title: '手续费', param: 'feeAmount', formatter: PriceFormat, width: 80 },
    { title: '提现渠道', param: 'withdrawChannel', width: 80 },
    // { title: '提现银行', param: 'bankName' },
    // { title: '提现卡号', param: 'accountNo', formatter: BandCardFormat },
    {
      title: '提现状态',
      param: 'withdrawStatus',
      slotName: 'withdrawStatus',
      width: 200
    }, // formatter: WithdrawStatusFormat,
    {
      title: '申请时间',
      param: 'createTime',
      formatter: DateFormat,
      width: 160
    },
    {
      title: '初审通过时间',
      param: 'firstPassTime',
      formatter: DateFormat,
      width: 160
    },
    {
      title: '申请通过时间',
      param: 'applyPassTime',
      formatter: DateFormat,
      width: 160
    },
    {
      title: '提现成功时间',
      param: 'withdrawSuccessTime',
      formatter: DateFormat,
      width: 160
    },
    {
      title: '审核拒绝时间',
      param: 'withdrawRejectTime',
      formatter: DateFormat,
      width: 160,
      hide: this.activeMenu == 'reject'
    },
    {
      title: '审核拒绝原因',
      param: 'withdrawRejectMsg',
      width: 160,
      overflow: true,
      hide: this.activeMenu == 'reject'
    },
    {
      title: '操作',
      width: 120,
      fixed: 'right',
      operation: [
        // { title: '查看详情', icon: 'el-icon-document',click: this.openDesc },
        {
          title: '初审',
          icon: 'el-icon-edit',
          click: this.openAudit,
          show: (data: any) => {
            return data.withdrawStatus == 0
          }
        },
        {
          title: '审核',
          icon: 'el-icon-edit',
          click: this.openAudit,
          show: (data: any) => {
            return data.withdrawStatus == 7 || data.withdrawStatus == 6
          }
        },
        { title: '查看店铺流水', click: this.openWealhRecord },
      ]
    }
  ]

  private tableSelectData: any[] = []
  private tableSelectChange(e: any[]) {
    this.tableSelectData = e
  }

  //。选择菜单
  private activeMenuSelect(e:string){
    if(this.activeMenu == e){
      return
    }
    this.activeMenu = e
    const ts = this.tableHander.filter(e=>e.param == 'withdrawRejectTime')
    const ts2 = this.tableHander.filter(e=>e.param == 'withdrawRejectMsg')
    if(e == 'reject'){
      ts[0].hide = false
      ts2[0].hide = false
    } else {
      ts[0].hide = true
      ts2[0].hide = true
    }
    this.search()
  }

  public async created() {
    this.loadShop()
    // this.loadData()
  }

  // 每次显示的时候查询下
  public activated(){
    console.log("activated")
    // 获取请求参数
    if (this.$route.query.withdrawSuccessTime) {
      this.queryParam.withdrawSuccessTimeDaterange = [this.$route.query.withdrawSuccessTime + ' 00:00:00',this.$route.query.withdrawSuccessTime + ' 23:59:59'];
    } else {
      this.queryParam.withdrawSuccessTimeDaterange = []
    }
    if (this.$route.query.applyPassTime) {
      this.queryParam.applyPassTimeDaterange = [this.$route.query.applyPassTime + ' 00:00:00',this.$route.query.applyPassTime + ' 23:59:59'];
    }else {
      this.queryParam.applyPassTimeDaterange = []
    }
    if (this.$route.query.withdrawRejectTime) {
      this.queryParam.withdrawRejectTimeDaterange = [this.$route.query.withdrawRejectTime + ' 00:00:00',this.$route.query.withdrawRejectTime + ' 23:59:59'];
    }else {
      this.queryParam.withdrawRejectTimeDaterange = []
    }
    if (this.$route.query.withdrawStatus) {
      const ws = Number(this.$route.query.withdrawStatus)
      if( ws == 4){
        this.activeMenuSelect('success')
      } else if(ws == 2){
        this.activeMenuSelect('reject')
      } else {
        this.loadData()
      }
    } else {
      this.loadData()
    }
    
  }

  public openWealhRecord(data: any) {
    const d = this.$refs.ShopWealhRecordDialog as any
    d.open({id:data.shopId,name:data.shopName})
  }

  private openAudit(data: any) {
    const d = this.$refs.WithdrawAuditDialog as WithdrawAuditDialog
    d.open(data)
  }

  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryWithdrawOrder(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam() {
    const param: any = { ...this.queryParam }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.createTimeDaterange.length > 0) {
      param.createTimes =
        DateFormat(param.createTimeDaterange[0]) +
        ',' +
        DateFormat(param.createTimeDaterange[1])
    }
    if (param.applyPassTimeDaterange.length > 0) {
      param.applyPassTimes =
        DateFormat(param.applyPassTimeDaterange[0]) +
        ',' +
        DateFormat(param.applyPassTimeDaterange[1])
    }
    if (param.withdrawSuccessTimeDaterange.length > 0) {
      param.withdrawSuccessTimes =
        DateFormat(param.withdrawSuccessTimeDaterange[0]) +
        ',' +
        DateFormat(param.withdrawSuccessTimeDaterange[1])
    }
    if (param.withdrawRejectTimeDaterange.length > 0) {
      param.withdrawRejectTimes =
        DateFormat(param.withdrawRejectTimeDaterange[0]) +
        ',' +
        DateFormat(param.withdrawRejectTimeDaterange[1])
    }

    // 根据选择菜单的不同查询不同的数据
    if(this.activeMenu == 'wait'){
      // 待处理
      param.withdrawStatusIn = [0,6,7]
    }else if(this.activeMenu == 'doing'){
      // 提现中
      param.withdrawStatus = 3
    } else if(this.activeMenu == 'success'){
      // 提现成功
      param.withdrawStatus = 4
    }  else if(this.activeMenu == 'reject'){
      // 提现成功
      param.withdrawStatus = 2
    }

    return param
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  private async loadShop() {
    const res = await QueryAllShopNameList({})
    const list = res.list
    this.shopIdOption = list.map((e: any) => {
      return { value: e.id, label: e.name }
    })

    this.shopIdQueryParam.selectData = this.shopIdOption
  }

  private exportHandle() {
    const loading = this.$loading({
      lock: true,
      text: '正在导出',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    const param: any = this.getRequestParam()
    param.limit = ''
    param.startRow = ''

    if (this.tableSelectData.length > 0) {
      const ids = this.tableSelectData.map((e) => e.id)
      param.ids = ids
    }

    ExportWithdrawOrder(param, '提现订单导出.xlsx')
      .then((res) => {
        loading.close()
      })
      .catch(() => {
        loading.close()
      })
  }
}
